import makeStyles from '@mui/styles/makeStyles';

export const formStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    '& .MuiDialogTitle-root': {
      overflow: 'visible',
    },
    '& .MuiDialogContent-root': {
      overflow: 'visible',
    },
  },
  submit: {
    margin: theme.spacing(2, 0, 2),
  },
  inputLabel: {
    userSelect: 'none',
    marginLeft: 1,
  },
  comments: {
    margin: 0,
  },
  actions: {
    '&.MuiDialogActions-root': {
      padding: theme.spacing(2, 3),
    },
  },
  gridStartIcon: {
    height: "36px",
    marginTop: "5px"
  },
  alert: {
    marginBottom: theme.spacing(1),
  },
  flowLabel: {
    display: 'flex',
    flexDirection: 'row',
    gap: 4,
    alignItems: 'center'
  },
  flowLabelText: {
    fontSize: "0.9em",
    fontWeight: 400,
    marginTop: '5px',
    marginLeft: '1em',
    color: "rgba(0,0,0,0.54)"
  }
}));
